import { Injectable } from '@angular/core';
import { IParsedAddress } from './address-parser.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationValidatorService {
  isWithinFourHours(appointmentDateTime: Date): boolean {
    const now = new Date();
    const fourHoursBeforeAppointment = new Date(appointmentDateTime.getTime() - (4 * 60 * 60 * 1000));

    return now >= fourHoursBeforeAppointment && now <= appointmentDateTime;
  }

  getTimeUntilFullAddressReveal(appointmentDate: string, appointmentTime: string): string {
    const appointmentDateTime = new Date(`${appointmentDate}T${appointmentTime}`);
    const fourHoursBeforeAppointment = new Date(appointmentDateTime.getTime() - (4 * 60 * 60 * 1000));
    const now = new Date();

    if (now >= fourHoursBeforeAppointment) {
      return 'Adresse complète disponible';
    }

    const timeDiff = fourHoursBeforeAppointment.getTime() - now.getTime();
    const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    if (hoursLeft > 0) {
      return `Adresse complète dans ${hoursLeft}h`;
    } else {
      return `Adresse complète dans ${minutesLeft}min`;
    }
  }

  getFormattedAddress(
    fullAddress: string,
    appointmentDate: string,
    appointmentTime: string,
    addressParser: { parseCanadianAddress: (addr: string) => IParsedAddress | null; formatFullAddress: (addr: IParsedAddress) => string; formatShortAddress: (addr: IParsedAddress) => string; getFallbackAddress: (addr: string) => string }
  ): string {
    if (!fullAddress) return 'Adresse non disponible';

    // Parser l'adresse
    const parsedAddress = addressParser.parseCanadianAddress(fullAddress);
    if (!parsedAddress) {
      // Fallback si le parsing échoue
      return addressParser.getFallbackAddress(fullAddress);
    }

    // Créer la date/heure du rendez-vous
    const appointmentDateTime = new Date(`${appointmentDate}T${appointmentTime}`);

    // Vérifier si on peut révéler l'adresse complète
    const canShowFullAddress = this.isWithinFourHours(appointmentDateTime);

    if (canShowFullAddress) {
      // Afficher l'adresse complète
      return addressParser.formatFullAddress(parsedAddress);
    } else {
      // Afficher la version raccourcie (ville + province seulement)
      return addressParser.formatShortAddress(parsedAddress);
    }
  }
}

